// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"54":"ce722431","112":"480ab5b5","545":"a0461151","705":"f42460c0","738":"21da7c5d","931":"8b049cac"}[chunkId] + ".js";
};